import React from 'react';
import { Button, Loader, useToggle } from '@oforce/global-components';

import { Render, TabPage } from '../../../components';
import { BodilyCoveragesDetails, VehicleCoveragesDetails } from '.';
import { useActiveAccount } from '../../../shared/activeAccount';
import { Row } from 'reactstrap';
import { AddInsuredStakeholder, InsuredStakeholdersTable } from '../../insuredStakeholder/components';
import { useHistory, useRouteMatch } from 'react-router-dom';
import InsuredInfo from './InsuredInfo';
import TerminateAllButton from './TerminateAllButton';
import { useInsuredElections } from '../../insuredElections/hooks';
import { HideFromRolesAndTypes } from '../../../shared/activeAccount/components';

export default function InsuredDetails({ insured }) {
  const [showAddStakeholder, toggleAddStakeholder] = useToggle();
  const history = useHistory();
  const { url } = useRouteMatch();
  const filterByInsuranceType = (elections, type) =>
    elections?.filter(election => election.policy?.insuranceType?.type === type);

  const { insuredElections, loading, error } = useInsuredElections({ insuredId: insured?.id });
  const insuredTypeElections = filterByInsuranceType(insuredElections, 'INSURED');
  const vehicleTypeElections = filterByInsuranceType(insuredElections, 'VEHICLE');
  const isApiOnlyExposureUpdates = insuredElections?.[0]?.policy?.apiOnlyExposureUpdates;

  const {
    roleIsAtLeast,
    ROLES: { OBSERVER, POLICY_MANAGER },
    TYPES: { CLAIMS_ADJUSTER },
    isAdmin
  } = useActiveAccount();

  const isAtLeastPolicyManager = roleIsAtLeast(POLICY_MANAGER);
  const hasBeneficiary = insured?.stakeholders?.length > 0;

  return (
    <>
      <Row>
        <TabPage
          title="Dashboard"
          onBack={() => history.goBack()}
          className="pr-4 flex-grow-1 "
          marginBottom="mb-0"
          contentClassName="mt-1"
          titleClassName="mb-1"
          buttons={
            <HideFromRolesAndTypes roles={[OBSERVER]} types={[CLAIMS_ADJUSTER]}>
              <Render if={ isAdmin || !isApiOnlyExposureUpdates }> 
                <Button color="info" icon={['far', 'pen']} onClick={() => history.push(`${url}/edit`)}>
                  Edit
                </Button>
                <Render if={isAtLeastPolicyManager}>
                  <TerminateAllButton
                    insured={insured}
                    insuredTypeElections={insuredTypeElections}
                    vehicleTypeElections={vehicleTypeElections}
                  />
                </Render>
              </Render>
            </HideFromRolesAndTypes>
          }
        >
          <InsuredInfo insured={insured} />
        </TabPage>
        <TabPage
          title="Beneficiary"
          marginBottom="mb-0"
          contentClassName="mt-1"
          titleClassName="mb-1"
          className="flex-grow-1 mt-0"
          buttons={
            <HideFromRolesAndTypes roles={[OBSERVER]} types={[CLAIMS_ADJUSTER]}>
              <Render if={!hasBeneficiary && (isAdmin || !isApiOnlyExposureUpdates)}>
                <Button className="mb-1" color="info" icon={['far', 'plus']} onClick={toggleAddStakeholder}>
                  Add Beneficiary
                </Button>
              </Render>
            </HideFromRolesAndTypes>
          }
        >
          <InsuredStakeholdersTable insured={insured} />
        </TabPage>
      </Row>
      {loading && <Loader />}
      {!loading && !error && (
        <>
          <Row>
            <BodilyCoveragesDetails coverages={insuredTypeElections} isApiOnlyExposureUpdates={isApiOnlyExposureUpdates}/>
          </Row>
          <Row>
            <VehicleCoveragesDetails coverages={vehicleTypeElections}  isApiOnlyExposureUpdates={isApiOnlyExposureUpdates}/>
          </Row>
        </>
      )}
      {showAddStakeholder && (
        <AddInsuredStakeholder insured={insured} isOpen={showAddStakeholder} toggle={toggleAddStakeholder} />
      )}
    </>
  );
}
